export default __webpack_public_path__ + "static/media/readme.437d4b1c.png";